import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
  Chip,
  Tooltip,
  Box,
  Typography,
  Divider
} from '@mui/material';
import useRoles from '../../../../hooks/roles';
import { EmployeeType } from '../create-employee-form/create-employee-form.interfaces';
import { Permission } from '../../../../interfaces/common/permissions';
import { RoleChips } from '../../../common/role-chips';
import { AdminPanelSettings } from '@mui/icons-material';


interface EmployeesListingTableProps {
  employees: EmployeeType[];
  isLoading: boolean;
}

function EmployeesListingTable({ employees, isLoading }: EmployeesListingTableProps) {

  const {roles, isLoading: rolesLoading} = useRoles()

  return (
    <TableContainer style={{ maxHeight: '80%' }}>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <b>Name</b>
              </TableCell>
              <TableCell align="center">
                <b>Phone</b>
              </TableCell>
              <TableCell align="center">
                <b>Branches</b>
              </TableCell>
              <TableCell align="center">
                <b>Permission Group(s)</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.map((employee) => (
              <TableRow key={employee.id}>
                <TableCell align="center">
                  <a href={`/employee/${employee.id}`}>
                    <b>{employee.name}</b>
                  </a>
                </TableCell>
                <TableCell align="center">{employee.phone_number}</TableCell>

                <TableCell align="center">{(employee.branches || []).map(x => x.name).join(' | ')}</TableCell>

                <TableCell align="center">
                { <RoleChips is_admin={employee.is_admin} key={employee.id} roles={employee.roles} allRoles={roles} allRolesLoading={rolesLoading} />}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
}

export default EmployeesListingTable;
